module.exports = __webpack_public_path__ + "assets/new-icon.07fbb835.svg";